export default "__VITE_ASSET__E41MsVdU__"